// src/components/condos/CondoShortRedirect.tsx
// Resolves a short condo URL (/c/:shortId) to the full detail page (/condos/:condoId)

import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { condoService } from '../../services/condoService';
import BackgroundShapes from '../common/BackgroundShapes';

const CondoShortRedirect: React.FC = () => {
  const { shortId } = useParams<{ shortId: string }>();
  const navigate = useNavigate();
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (!shortId) {
      setNotFound(true);
      return;
    }

    const resolve = async () => {
      try {
        const res = await condoService.getCondoByShortId(shortId);
        if (res.success && res.data?.condo) {
          const condoId = res.data.condo.id ?? res.data.condo._id;
          navigate(`/condos/${condoId}`, { replace: true });
        } else {
          setNotFound(true);
        }
      } catch {
        setNotFound(true);
      }
    };

    resolve();
  }, [shortId, navigate]);

  if (notFound) {
    return (
      <div className="min-h-screen bg-paper relative">
        <BackgroundShapes />
        <div className="container mx-auto px-4 py-12 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <p className="text-coffee text-xl mb-4">This listing could not be found.</p>
            <button
              onClick={() => navigate('/condos')}
              className="bg-terracotta text-white px-4 py-2 rounded-lg font-semibold"
            >
              Browse Condos
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-paper relative">
      <BackgroundShapes />
      <div className="container mx-auto px-4 py-12 relative z-10">
        <div className="max-w-4xl mx-auto text-center text-coffee text-xl">
          Loading...
        </div>
      </div>
    </div>
  );
};

export default CondoShortRedirect;
